import { useState, useRef } from 'react';
import { toast } from 'react-toastify';

const useVoiceRecorder = () => {
  const [isRecording, setIsRecording] = useState(false);
  const [audioBlob, setAudioBlob] = useState(null);
  const mediaRecorderRef = useRef(null);

  const startRecording = () => {
    navigator.mediaDevices.getUserMedia({ audio: true })
      .then((stream) => {
        const mediaRecorder = new MediaRecorder(stream);
        mediaRecorderRef.current = mediaRecorder;

        mediaRecorder.start();
        setIsRecording(true);

        mediaRecorder.ondataavailable = (event) => {
          setAudioBlob(event.data);
        };

        mediaRecorder.onstop = () => {
          setIsRecording(false);
        };
      })
      .catch((error) => {
        toast.error("Error accessing microphone")
        console.error("Error accessing microphone: ", error);
      });
  };

  const stopRecording = () => {
    mediaRecorderRef.current.stop();
  };

  return { isRecording, audioBlob, startRecording, stopRecording, setAudioBlob };
};

export default useVoiceRecorder;
